// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingSpinner_spinner__Razfz","pageLoadingContainer":"LoadingSpinner_pageLoadingContainer__2bAok","componentLoader":"LoadingSpinner_componentLoader__i+DSj"};